import { useEffect } from 'react';

import Icon from '@ant-design/icons';

import Image from 'global/Image';
import { LightningBoxSvg } from 'features/day-trade/components/Icons';

import {
  clevertapDayTradeActivationSuccessViewed,
  clevertapDayTradeActivationSuccessSelected,
} from 'lib/analytics/securities';

import BaseSecuritiesModal from 'global/Securities/components/Modal/BaseSecuritiesModal';
import type { BaseSecuritiesModalProps } from 'global/Securities/components/Modal/BaseSecuritiesModal';

import {
  ActionWrapper,
  Container,
  ContentWrapper,
  Description,
  FinishButton,
  Title,
} from './confirmation.styled';

const DayTradeConfirmation = ({
  onCancel = () => {},
  onSubmit = () => {},
  ...props
}: BaseSecuritiesModalProps) => {
  const handleSubmit = () => {
    onSubmit();
    clevertapDayTradeActivationSuccessSelected();
  };

  useEffect(() => {
    clevertapDayTradeActivationSuccessViewed();
  }, []);

  return (
    <BaseSecuritiesModal
      closable={false}
      modalWidth={415}
      onCancel={onCancel}
      hideSubmit
      {...props}
    >
      <Container>
        <ContentWrapper>
          <Image
            src="/images/day-trade/confirmation-success.svg"
            alt="Day Trade Success"
            height="120"
            width="160"
          />
          <Title>Day Trade Berhasil Diaktifkan</Title>
          <Description>
            Kamu sudah bisa melakukan Day Trade di semua saham yang memiliki
            simbol{' '}
            <span>
              <Icon component={LightningBoxSvg} />
            </span>
          </Description>
        </ContentWrapper>

        <ActionWrapper>
          <FinishButton onClick={handleSubmit} type="primary">
            Selesai
          </FinishButton>
        </ActionWrapper>
      </Container>
    </BaseSecuritiesModal>
  );
};

export default DayTradeConfirmation;
